<template>
    <div style="position: relative;">
        <tree ref="dataTree" style="min-height:50vh"
              :data="dataList"
              :width="width"
              :nodeKey="nodeKey"
              :expandedKeys="expandedKeys"
              :treeConfig="treeConfig"
              @selTree="selTree"
              v-loading="loading"></tree>
    </div>
</template>

<script>
    import tree from "./index"

    export default {
        name: "dataTree",
        components: {
            tree
        },
        props: ['width','topData','dataUrl','childUrl'],
        data() {
            return {
                dataList: [],
                treeConfig: {
                    children: 'children',
                    label: 'name',
                },
                nodeKey: 'id',
                expandedKeys: ["0"],
                loading: false,

            }

        },
        async mounted() {
            await this.getDataList();
        },
        methods: {
            async getDataList() {
                this.loading = true;
                let param = {
                    url:this.dataUrl,
                    param:{
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                const retData = data.data.jsonStr;
                if(retData){
                    if(this.topData){
                        this.topData.children = retData;
                        this.dataList = [this.topData];
                    }else{
                        this.dataList = retData;
                    }
                }
                this.loading = false;
            },
            async refreshTree() {
                await this.getDataList();
            },
            selTree(data) {
                this.$emit('selTree', data);
                //this.handleNodeClick(data);
            },
        }
    }

</script>

<style lang="scss">

</style>
